module.exports = __webpack_public_path__ + "img/4-1.7e518717.jpg";